export const trafficRulesData = {
  english: {
    title: "Traffic Rules & Fines",
    headers: {
      violation: "Violations",
      fine: "Fine or Penalty",
    },
    rows: [
      {
        v: "Driving without a valid driving license",
        f: "Minimum Rs. 25,000",
      },
      {
        v: "Driving under the influence of alcohol or drugs",
        f: "Minimum Rs. 25,000",
      },
      {
        v: "Driving without valid insurance",
        f: "Minimum Rs. 25,000",
      },
      {
        v: "Driving into an unprotected railway crossing unsafely",
        f: "Minimum Rs. 25,000",
      },
      {
        v: "Speeding up to 20% over speed limit",
        f: "Rs. 3,000",
      },
      {
        v: "Speeding – 20–30% over limit",
        f: "Rs. 5,000",
      },
      {
        v: "Speeding – 30–50% over limit",
        f: "Rs. 10,000",
      },
      {
        v: "Speeding – over 50% above limit",
        f: "Rs. 15,000",
      },
      {
        v: "Expressway speed 140–150 km/h",
        f: "Rs. 15,000",
      },
      {
        v: "Expressway speed 120–130 km/h",
        f: "Rs. 15,000",
      },
      {
        v: "Expressway speed 130–140 km/h",
        f: "Rs. 15,000",
      },
      {
        v: "If speed exceeds 150 km/h on expressway",
        f: "Rs. 15,000",
      },
      {
        v: "Exceeding certain speeds on expressways (100–120 km/h)",
        f: "Legal action (court)",
      },
      {
        v: "Reckless driving",
        f: "Minimum Rs. 10,000",
      },
      {
        v: "Not wearing seat belt",
        fMain: "Increased fine",
        fSub: "(not less than Rs. 5,000 up to Rs. 30,000, depending on degree)",
      },
      {
        v: "Driving by underage persons",
        fMain: "Fine increased",
        fSub: "(was about Rs. 1,000 for seatbelt / non-seatbelt offences)",
      },
    ],
  },

  sinhala: {
    title: "රථවාහන නීති හා දඩ මුදල්",
    headers: {
      violation: "උල්ලංඝන",
      fine: "දඩ මුදල / දඬුවම",
    },
    rows: [
  {
    v: "වලංගු රියදුරු බලපත්‍රයක් නොමැතිව රිය පැදවීම",
    f: "අවම රු. 25,000",
  },
  {
    v: "මත්පැන් හෝ මත්ද්‍රව්‍ය බලපෑම යටතේ රිය පැදවීම",
    f: "අවම රු. 25,000",
  },
  {
    v: "වලංගු රක්ෂණයක් නොමැතිව රිය පැදවීම",
    f: "අවම රු. 25,000",
  },
  {
    v: "ආරක්ෂාව නොමැති දුම්රිය මාර්ග හරහා අනාරක්ෂිත ලෙස ධාවනය කිරීම",
    f: "අවම රු. 25,000",
  },
  {
    v: "වේග සීමාවට වඩා 20% දක්වා අධික වේගයෙන් ධාවනය කිරීම",
    f: "රු. 3,000",
  },
  {
    v: "වේග සීමාවට වඩා 20%–30% අධික වේගයෙන් ධාවනය කිරීම",
    f: "රු. 5,000",
  },
  {
    v: "වේග සීමාවට වඩා 30%–50% අධික වේගයෙන් ධාවනය කිරීම",
    f: "රු. 10,000",
  },
  {
    v: "වේග සීමාවට වඩා 50% කට වඩා අධික වේගයෙන් ධාවනය කිරීම",
    f: "රු. 15,000",
  },
  {
    v: "අධිවේගී මාර්ගයේ 140–150 km/h වේගයෙන් ධාවනය කිරීම",
    f: "රු. 15,000",
  },
  {
    v: "අධිවේගී මාර්ගයේ 120–130 km/h වේගයෙන් ධාවනය කිරීම",
    f: "රු. 15,000",
  },
  {
    v: "අධිවේගී මාර්ගයේ 130–140 km/h වේගයෙන් ධාවනය කිරීම",
    f: "රු. 15,000",
  },
  {
    v: "අධිවේගී මාර්ගයේ 150 km/h ඉක්මවා ධාවනය කිරීම",
    f: "රු. 15,000",
  },
  {
    v: "අධිවේගී මාර්ගයේ නියමිත වේග සීමාවන් ඉක්මවා ධාවනය කිරීම (100–120 km/h)",
    f: "නීතිමය ක්‍රියාමාර්ග (අධිකරණය)",
  },
  {
    v: "අවිනීත / අනාරක්ෂිත රිය පැදවීම",
    f: "අවම රු. 10,000",
  },
  {
    v: "ආරක්ෂිත පටි (Seat belt) නොපැළඳීම",
    fMain: "දඩ මුදල වැඩි කර ඇත",
    fSub: "(අවම රු. 5,000 සිට රු. 30,000 දක්වා – වරදේ බරපතලභාවය අනුව)",
  },
  {
    v: "අවයස්කාර පුද්ගලයන් විසින් රිය පැදවීම",
    fMain: "දඩ මුදල වැඩි කර ඇත",
    fSub: "(පෙර ආසන්න වශයෙන් රු. 1,000ක් විය – Seat belt / Non-seat belt වරද සඳහා)",
  },
],

  },

  tamil: {
    title: "போக்குவரத்து விதிகள் மற்றும் அபராதங்கள்",
    headers: {
      violation: "மீறல்கள்",
      fine: "அபராதம் / தண்டனை",
    },
   rows: [
  {
    v: "செல்லுபடியாகும் ஓட்டுநர் உரிமம் இல்லாமல் வாகனம் ஓட்டுதல்",
    f: "குறைந்தபட்சம் ரூ. 25,000",
  },
  {
    v: "மதுபானம் அல்லது போதைப்பொருள் பாதிப்பில் வாகனம் ஓட்டுதல்",
    f: "குறைந்தபட்சம் ரூ. 25,000",
  },
  {
    v: "செல்லுபடியாகும் காப்பீடு இல்லாமல் வாகனம் ஓட்டுதல்",
    f: "குறைந்தபட்சம் ரூ. 25,000",
  },
  {
    v: "பாதுகாப்பற்ற ரயில் கடவை வழியாக அபாயகரமாக வாகனம் செலுத்துதல்",
    f: "குறைந்தபட்சம் ரூ. 25,000",
  },
  {
    v: "வேக வரம்பை 20% வரை மீறி ஓட்டுதல்",
    f: "ரூ. 3,000",
  },
  {
    v: "வேக வரம்பை 20%–30% வரை மீறி ஓட்டுதல்",
    f: "ரூ. 5,000",
  },
  {
    v: "வேக வரம்பை 30%–50% வரை மீறி ஓட்டுதல்",
    f: "ரூ. 10,000",
  },
  {
    v: "வேக வரம்பை 50% க்கும் மேல் மீறி ஓட்டுதல்",
    f: "ரூ. 15,000",
  },
  {
    v: "அதிவேக நெடுஞ்சாலையில் 140–150 km/h வேகத்தில் ஓட்டுதல்",
    f: "ரூ. 15,000",
  },
  {
    v: "அதிவேக நெடுஞ்சாலையில் 120–130 km/h வேகத்தில் ஓட்டுதல்",
    f: "ரூ. 15,000",
  },
  {
    v: "அதிவேக நெடுஞ்சாலையில் 130–140 km/h வேகத்தில் ஓட்டுதல்",
    f: "ரூ. 15,000",
  },
  {
    v: "அதிவேக நெடுஞ்சாலையில் 150 km/h ஐ மீறி ஓட்டுதல்",
    f: "ரூ. 15,000",
  },
  {
    v: "அதிவேக நெடுஞ்சாலைகளில் குறிப்பிட்ட வேக வரம்புகளை மீறுதல் (100–120 km/h)",
    f: "சட்ட நடவடிக்கை (நீதிமன்றம்)",
  },
  {
    v: "அபாயகரமான / கவனக்குறைவான ஓட்டுதல்",
    f: "குறைந்தபட்சம் ரூ. 10,000",
  },
  {
    v: "பாதுகாப்புப் பட்டை (Seat belt) அணியாமல் ஓட்டுதல்",
    fMain: "அபராதம் அதிகரிக்கப்பட்டுள்ளது",
    fSub: "(குறைந்தபட்சம் ரூ. 5,000 முதல் ரூ. 30,000 வரை – குற்றத்தின் அளவைப் பொறுத்து)",
  },
  {
    v: "அவயது குறைந்தவர்களால் வாகனம் ஓட்டுதல்",
    fMain: "அபராதம் அதிகரிக்கப்பட்டுள்ளது",
    fSub: "(முன்பு சுமார் ரூ. 1,000 – Seat belt / Non-seat belt குற்றங்களுக்கு)",
  },
],

  },
};
